/* eslint-disable jsx-a11y/anchor-is-valid */
import { BrandingStyled, LoginStyled } from "./login.styles";
import branding from "../../assets/images/login-branding.png";
import { Box, Typography } from "@mui/material";
import TextInputFormField from "../../components/form-fields/text-input-field/text-input-form-field";
import { useForm } from "react-hook-form";
import BaseForm from "../../components/base-form/base-form";
import { PrimaryButton } from "../../components/button/button";
import { loginUser } from "../../actions";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginFormValidation } from "../../utils/validations";
import { LoginResponse } from "./types";
import { useNavigate } from "react-router-dom";
import { setUserInSession } from "../../utils/common-utils";
import { useAppDispatch } from "../../store/hooks";
import { addNotification } from "../../store/slices/ui-slice";
import { v4 as uuid } from "uuid";

export const Branding: React.FC = () => {
  return (
    <BrandingStyled>
      <img src={branding} alt="Branding" />
    </BrandingStyled>
  );
};

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { control, watch, formState, handleSubmit } = useForm({
    mode: "all",
    resolver: yupResolver(loginFormValidation()),
  });

  const onSubmit = () => {
    setIsLoading(true);
    loginUser({ ...watch() })
      .then((response: LoginResponse) => {
        const { message, data } = response;
        setUserInSession({
          token: data.token,
          name: data.user.name,
          email: data.user.email,
        });
        dispatch(
          addNotification({
            id: uuid(),
            type: "success",
            message: message,
          })
        );
        sessionStorage.setItem("hasReloaded", "true");
        window.location.href = "/dashboard";
      })
      .catch((error) => {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: error.response?.data?.message || error.message,
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const isValid = formState?.isValid;

  return (
    <LoginStyled>
      <Box className="container">
        <div className="form-wrapper">
          <Typography className="title">Login</Typography>
          <form onSubmit={handleSubmit(onSubmit)}>
            <BaseForm>
              <TextInputFormField
                name="email"
                label="Your email"
                control={control}
                placeholder="Enter here"
              />
              <div>
                <TextInputFormField
                  name="password"
                  label="Password"
                  inputType="password"
                  control={control}
                  placeholder="Enter here"
                />
                <div
                  className="forgot-password"
                  onClick={() => navigate("/reset")}
                >
                  <Typography className="forgot">
                    Forgot your password?
                  </Typography>
                </div>
              </div>
            </BaseForm>
            <Box className="buttons-container">
              <PrimaryButton
                isLoading={isLoading}
                disabled={!isValid}
                type="submit"
              >
                Login
              </PrimaryButton>
            </Box>
          </form>
        </div>
      </Box>
      <Branding />
    </LoginStyled>
  );
};

export default Login;
